function getSubscribeOnce(_ref) {
  var messageBus = _ref.messageBus;
  return function subscribeOnce(topic, callback) {
    messageBus.subscribe(topic, function (_, data) {
      messageBus.unsubscribe(topic);
      callback(data);
    });
  };
}

export default getSubscribeOnce;